import React from 'react';

type Status = 'live' | 'degraded' | 'building' | 'offline' | 'checking';

interface StatusBadgeProps {
  status: Status;
}

const LABELS: Record<Status, string> = {
  live: 'Live',
  degraded: 'Degraded',
  building: 'Building',
  offline: 'Offline',
  checking: 'Checking',
};

export default function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <span className={`domain-status status-${status}`}>
      <span className={`status-dot${status === 'checking' ? ' status-dot-pulse' : ''}`} />
      {LABELS[status]}
    </span>
  );
}
